/*
 * @Author: Jason
 * @Date: 2020-09-11 14:03:51
 * @LastEditors: Jason
 * @LastEditTime: 2020-10-10 14:13:39
 */
const state = {
  total: 0,
  page: 0,
  pageIndex: 1,
  limit: 10,
  list: [],
  offset: 0,

}

const mutations = {
  SET_RECORD_OFFSET(state, { payload }) {
    state.limit = (payload && payload.limit) || 10
    state.offset = (payload && payload.offset) || 0
  },
  SET_RECORD_LIST(state, { payload }) {
    state.total = payload.total
    state.list = payload.list
  },
}

const actions = {
  setRecordOffset({ commit }, payload) {
    // do something async
    commit('SET_RECORD_OFFSET', {
      payload: payload
    })
  },
  setRecordList({ commit }, payload) {
    // do something async
    commit('SET_RECORD_LIST', {
      payload: payload
    })
  },
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Record.js